import { type BaseCurrencyType } from '@pkg/types';

import { type ExchangeRates } from './types';

// Default exchange rates were collected on 18/08/2023.
export const INITIAL_RATES: ExchangeRates = {
    apt: 5.79,
    eth: 1_670.17,
    matic: 0.57,
    usd: 1,
};

// TODO: We should have a source of truth for all supported currency's
// "divisible length". Better yet, we replace this function with `viem`.
export const CURRENCY_DECIMALS: Record<BaseCurrencyType, number> = {
    apt: 8,
    eth: 18,
    matic: 18,
    usd: 2,
};

// This object is used to better presentation of price values.
export const PRETTY_DECIMALS = {
    usd: 2,
    crypto: {
        full: 18,
        ideal: 8,
        compact: 4,
    },
};
